/**
 * バンドルミックスマッチ設定画面　プロモーション商品情報VOクラス
 */
export class KYMW1308PromotionGoodsInfoModel {

  // プロモーションＮＯ
  public promotionNo: string = <string>'';

  // プロモーション名称
  public promotionName: string = <string>'';

  // プロモーション区分
  public promotionDiv: string = <string>'';

  // プロモーション区分名
  public promotionDivName: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  // 商品案内用商品名
  public guideGoodsName: string = <string>'';

  // 商品案内用規格名
  public guideStandardName: string = <string>'';

  // いばらき　　取扱フラグ
  public handlingFlgIB: string = <string>'0';

  // いばらき　　供給価格（税込）
  public thisTimeSupplyPriceIB: string = <string>'';

  // いばらき　　仕入価格
  public thisTimeCostPriceIB: string = <string>'';

  // いばらき　　プロモーションフラグ
  public promotionFlgIB: string = <string>'';

  // いばらき　　成立数量
  public approvedNumIB: string = <string>'';

  // いばらき　　成立価格
  public approvedPriceIB: string = <string>'';

  // いばらき　　わくわくポイント
  public wakuwakuPointIB: string = <string>'';

  // とちぎ　　　取扱フラグ
  public handlingFlgTO: string = <string>'0';

  // とちぎ　　　供給価格（税込）
  public thisTimeSupplyPriceTO: string = <string>'';

  // とちぎ　　　仕入価格
  public thisTimeCostPriceTO: string = <string>'';

  // とちぎ　　　プロモーションフラグ
  public promotionFlgTO: string = <string>'';

  // とちぎ　　　成立数量
  public approvedNumTO: string = <string>'';

  // とちぎ　　　成立価格
  public approvedPriceTO: string = <string>'';

  // とちぎ　　　わくわくポイント
  public wakuwakuPointTO: string = <string>'';

  // ぐんま　　　取扱フラグ
  public handlingFlgGU: string = <string>'0';

  // ぐんま　　　供給価格（税込）
  public thisTimeSupplyPriceGU: string = <string>'';

  // ぐんま　　　仕入価格
  public thisTimeCostPriceGU: string = <string>'';

  // ぐんま　　　プロモーションフラグ
  public promotionFlgGU: string = <string>'';

  // ぐんま　　　成立数量
  public approvedNumGU: string = <string>'';

  // ぐんま　　　成立価格
  public approvedPriceGU: string = <string>'';

  // ぐんま　　　わくわくポイント
  public wakuwakuPointGU: string = <string>'';

  // ちば　　　　取扱フラグ
  public handlingFlgTI: string = <string>'0';

  // ちば　　　　供給価格（税込）
  public thisTimeSupplyPriceTI: string = <string>'';

  // ちば　　　　仕入価格
  public thisTimeCostPriceTI: string = <string>'';

  // ちば　　　　プロモーションフラグ
  public promotionFlgTI: string = <string>'';

  // ちば　　　　成立数量
  public approvedNumTI: string = <string>'';

  // ちば　　　　成立価格
  public approvedPriceTI: string = <string>'';

  // ちば　　　　わくわくポイント
  public wakuwakuPointTI: string = <string>'';

  // さいたま　　取扱フラグ
  public handlingFlgSA: string = <string>'0';

  // さいたま　　供給価格（税込）
  public thisTimeSupplyPriceSA: string = <string>'';

  // さいたま　　仕入価格
  public thisTimeCostPriceSA: string = <string>'';

  // さいたま　　プロモーションフラグ
  public promotionFlgSA: string = <string>'';

  // さいたま　　成立数量
  public approvedNumSA: string = <string>'';

  // さいたま　　成立価格
  public approvedPriceSA: string = <string>'';

  // さいたま　　わくわくポイント
  public wakuwakuPointSA: string = <string>'';

  // とうきょう　取扱フラグ
  public handlingFlgTK: string = <string>'0';

  // とうきょう　供給価格（税込）
  public thisTimeSupplyPriceTK: string = <string>'';

  // とうきょう　仕入価格
  public thisTimeCostPriceTK: string = <string>'';

  // とうきょう　プロモーションフラグ
  public promotionFlgTK: string = <string>'';

  // とうきょう　成立数量
  public approvedNumTK: string = <string>'';

  // とうきょう　成立価格
  public approvedPriceTK: string = <string>'';

  // とうきょう　わくわくポイント
  public wakuwakuPointTK: string = <string>'';

  // ながの　　　取扱フラグ
  public handlingFlgNA: string = <string>'0';

  // ながの　　　供給価格（税込）
  public thisTimeSupplyPriceNA: string = <string>'';

  // ながの　　　仕入価格
  public thisTimeCostPriceNA: string = <string>'';

  // ながの　　　プロモーションフラグ
  public promotionFlgNA: string = <string>'';

  // ながの　　　成立数量
  public approvedNumNA: string = <string>'';

  // ながの　　　成立価格
  public approvedPriceNA: string = <string>'';

  // ながの　　　わくわくポイント
  public wakuwakuPointNA: string = <string>'';

  // にいがた　　取扱フラグ
  public handlingFlgNI: string = <string>'0';

  // にいがた　　供給価格（税込）
  public thisTimeSupplyPriceNI: string = <string>'';

  // にいがた　　仕入価格
  public thisTimeCostPriceNI: string = <string>'';

  // にいがた　　プロモーションフラグ
  public promotionFlgNI: string = <string>'';

  // にいがた　　成立数量
  public approvedNumNI: string = <string>'';

  // にいがた　　成立価格
  public approvedPriceNI: string = <string>'';

  // にいがた　　わくわくポイント
  public wakuwakuPointNI: string = <string>'';

  // 項番2059 START
  // クルコ　　取扱フラグ
  public handlingFlgKU: string = <string>'0';

  // クルコ　　供給価格（税込）
  public thisTimeSupplyPriceKU: string = <string>'';

  // クルコ　　仕入価格
  public thisTimeCostPriceKU: string = <string>'';

  // クルコ　　プロモーションフラグ
  public promotionFlgKU: string = <string>'';

  // クルコ　　成立数量
  public approvedNumKU: string = <string>'';

  // クルコ　　成立価格
  public approvedPriceKU: string = <string>'';

  // クルコ　　わくわくポイント
  public wakuwakuPointKU: string = <string>'';

}
